// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2dXKv","upload":"Small_upload__OuYiA","imageWrap":"Small_imageWrap__3KgHw","removeBtn":"Small_removeBtn__3Vf5t"};